<template>
    <div class="title">
        <span
            class="title"
            :class="[`${item.entityType}_${item.educationType}`]"
        >{{ title }}</span>
    </div>
</template>

<script>
import {getEducationProgramTypeName} from '@/tools/education';

export default {
    name: 'ProgramCardTitle',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        title() {
            return getEducationProgramTypeName(this.item);
        },
    },
};
</script>

<style scoped lang="scss">
    @import '@/styles/track';
    @import '~@/styles/rem';

    .title {
        display: flex;
        align-items: center;

        span {
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            color: #98A0A9;

            @include on-xs {
                font-size: 12px;
                line-height: 20px;
            }

            @each $type, $color in $educationalProgramTypes {
                &.#{$type}::before {
                    margin-right: 6px;
                    background-color: $color;
                    content: " ";
                    display: block;
                    border-radius: 50%;
                    width: 8px;
                    height: 8px;
                }
            }
        }
    }
</style>